<template>
  <div id="main" v-bind:class="['page-' + $route.name, {menuopen: showMobileMenu}]">

    <Intro v-show="introAnimation"/>

    <div ref="ResponsiveMenuContainer" class="responsive-menu-container" v-bind:class="{ menuopen: showMobileMenu }">
      <div ref="ResponsiveMenuIcon" id="nav-icon1" v-on:click="showMobileMenu = !showMobileMenu">
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="responsive-menu">
        <div class="menu-logo"></div>
        <ul ref="ResponsiveMenu" id="responsive-nav">
          <li v-for="(slide, index) in slides" v-if="!loading" v-on:click="showMobileMenu = !showMobileMenu">
            <router-link v-on:click.native="goToSlide"
                         :to="{ name: getPageRoute(slide), params: { pageInfo: slide.pagina_collegata }}"
                         :data-slide="index">
              {{ slide.linkTitle }}
            </router-link>
          </li>
        </ul>
        <ul ref="MobileSocialList" id="social-list" class="mobile">
          <li class="social linkedin"><a target="_blank" href="https://www.linkedin.com/company/gabiano-holding/"><span>linkedin</span></a>
          </li>
          <li class="social instagram"><a target="_blank" href="https://www.instagram.com/gabianoholding/?hl=it"><span>instagram</span></a>
          </li>
          <li class="social twitter"><a target="_blank"
                                        href="https://twitter.com/GabianoHolding"><span>twitter</span></a></li>
          <li class="social youtube"><a target="_blank"
                                        href="https://www.youtube.com/channel/UCn3JR9cneaCpbm90pqbdo5A?disable_polymer=true"><span>youtube</span></a>
          </li>
        </ul>
      </div>
    </div>

    <div id="main-container" v-bind:class="{ menuopen: showMobileMenu }">

      <div id="header-container">
        <div class="header-bg"></div>

        <Header/>

        <div>
          <ul ref="Menu" id="nav">
            <li v-for="(slide, index) in slides" v-if="!loading"
                v-bind:class="{ active: index <= indexSlideActive }">
              <router-link v-on:click.native="goToSlide"
                           :to="{ name: getPageRoute(slide), params: { pageInfo: slide }}"
                           :data-slide="index">
                {{ slide.linkTitle }}
              </router-link>
            </li>
          </ul>

          <ul ref="SocialList" id="social-list" class="desktop">
            <li class="social linkedin"><a target="_blank"
                                           href="https://www.linkedin.com/company/gabiano-holding/"><span>linkedin</span></a>
            </li>
            <li class="social instagram"><a target="_blank"
                                            href="https://www.instagram.com/gabianoholding/?hl=it"><span>instagram</span></a>
            </li>
            <li class="social twitter"><a target="_blank" href="https://twitter.com/GabianoHolding"><span>twitter</span></a>
            </li>
            <li class="social youtube"><a target="_blank"
                                          href="https://www.youtube.com/channel/UCn3JR9cneaCpbm90pqbdo5A?disable_polymer=true"><span>youtube</span></a>
            </li>
          </ul>
        </div>
      </div>

      <v-touch @swipeleft="slideRight" @swiperight="slideLeft">
        <div ref="swipe-area" class="swipe-area" v-on:wheel.prevent="slideScroll" v-show="slickVisible"></div>
      </v-touch>

      <slick ref="slick" :options="slickOptions" v-bind="{testate}" class="slides-wrapper"
             @beforeChange="handleBeforeChange"
             @ended=""
             v-show="slickVisible">
        <div v-for="slide in slides">
          <Slide @loadingPageVue="showRouterView" :slide="slide"/>
        </div>
      </slick>

      <Loading/>

      <div class="p-content">
        <router-view :key="$route.fullPath" :routepath="$route.fullPath" :pageUUID="pageUUID" :pagePath="pagePath"
                     v-if="!loading"/>
      </div>

      <Footer v-show="!isHome" v-if="!loading"/>
      <transition name="fade">
        <FooterHome v-show="isHome" v-if="!loading"/>
      </transition>
    </div>
    <back-to-top visibleoffset="500">
      <div class="btn-to-top"></div>
    </back-to-top>
  </div>
</template>

<script>
import Slide from '@/components/Slide.vue'
import Header from '@/components/Header.vue'
import Slick from 'vue-slick';
import Footer from '@/components/Footer.vue'
import FooterHome from '@/components/FooterHome.vue'
import Intro from '@/components/Intro.vue'
import {store} from '@/global.js';
import Loading from '@/components/elements/Loading.vue'
import Waterwheel from "waterwheel"
import jsonapiParse from "jsonapi-parse";

const waterwheel = new Waterwheel(
    {
      base: process.env.VUE_APP_HOST_URL,
      jsonapiPrefix: 'api',
      timeout: 3000,
      accessCheck: false
    }
);
const query = {
  filter: {
    status: 1
  },
  include: 'pagina_collegata, immagine, video',
  sort: 'ordinamento'
}
export default {
  name: 'Slides',
  store,
  data() {
    return {
      loading: true,
      slides: [],
      testate: [],
      showPage: false,
      currentSlide: 0,
      page: [],
      pageUUID: '',
      pageUUIDs: [],
      pagePath: '',
      pagePaths: [],
      showMobileMenu: false,
      isHome: false,
      introAnimation: false,
      indexSlideActive: 0,
      slickVisible: false,
      scrollAnimActive: true,
      heightWrapper: 0,
      slickOptions: {
        slidesToShow: 1,
        infinite: false,
        speed: 1000,
        accessibility: true,
        adaptiveHeight: false,
        arrows: true,
        draggable: false,
        useTransform: true,
        cssEase: 'cubic-bezier(.7, .0, .0, 1)',
        edgeFriction: 0.2,
        swipe: false
      }
    }
  },
  metaInfo() {
    return {
      title: this.isHome ? 'Gabiano Holding - Crescere è il nostro obiettivo comune' : '',
      //  titleTemplate: '%s - Gabiano Holding',
    }
  },
  created() {
    waterwheel.jsonapi.get('node/testate', query).then(slides => {
      this.slides = jsonapiParse.parse(slides).data;
      this.reInit();
    })
        .catch(error => console.log('error on getSlides: ', error))
        .finally(() => {
          let front = true;
          this.page.loaded = 0;

          this.slides.forEach((slide, index) => {
            let pagePath = slide.path.alias.replace(/slide-/, '');
            this.pagePaths.push(pagePath);
            this.pageUUIDs.push(slide.pagina_collegata.id);

            if (pagePath === this.$route.path) {
              this.$refs.slick.goTo(index, false);
              front = false;
              this.indexSlideActive = index;
              this.pageUUID = slide.pagina_collegata.id;
              this.pagePath = pagePath;
            }

            slide.linkTitle = slide.pagina_collegata.title;
            this.page[index] = slide.linkTitle;
            this.slides[index].linkTitle = slide.linkTitle;
            this.page.loaded++;
            if (this.page.loaded === this.slides.length) {
              this.loading = false
            }
            this.homeStatus();

            this.loading = false;
          });
          this.setHeightWrapper();
        });

    this.slickStatus();
  },
  methods: {
    getPageRoute(slide) {
      let pagePath = slide.path.alias;
      return pagePath.replace(/\/slide-/, '');
    },
    showRouterView() {
      this.showPage = true;
    },
    goToSlide(e) {
      let slide = e.target.dataset.slide;
      this.goToNumSlide(slide);
    },
    goToNumSlide(index) {
      this.$refs.slick.goTo(index, false);
      this.indexSlideActive = index;
    },
    // Slick events.
    reInit() {
      // Fix v-for bug on slick.
      // https://github.com/staskjs/vue-slick/issues/52
      let currIndex = this.$refs.slick.currentSlide();
      this.$refs.slick.destroy();
      this.$nextTick(() => {
        this.$refs.slick.create();
        this.$refs.slick.goTo(currIndex, true);
      })
      this.setHeightWrapper();
    },
    handleBeforeChange(event, slick, currentSlide, nextSlide) {
      let navCurrent = $('#nav a[data-slide=' + nextSlide + ']').attr('href');
      if (navCurrent) {
        this.$router.push(navCurrent);
        this.indexSlideActive = nextSlide;
      }
      this.currentSlide = currentSlide;
      //this.showPage = false;
    },
    // Timer slide scroll by wheel.
    enableScrollAnim() {
      this.scrollAnimActive = true;
    },
    // Slide scroll by wheel.
    slideScroll(e) {
      // this.$refs.swipe-area.disable();
      if (this.scrollAnimActive === true) {
        this.scrollAnimActive = false;
        setTimeout(this.enableScrollAnim, 2000);
        if (e.deltaX === "-0") {
          if (e.deltaY < 0) {
            this.slideLeft()
          }
          if (e.deltaY > 0) {
            this.slideRight()
          }
        }
        if (e.deltaY === "-0") {
          if (e.deltaX < 0) {
            this.slideLeft()
          }
          if (e.deltaX > 0) {
            this.slideRight()
          }
        }
      }

    },
    // Slide scroll by swipe.
    slideLeft() {
      this.$refs.slick.prev();
      this.setHeightWrapper();
    },
    slideRight() {
      this.$refs.slick.next();
      this.setHeightWrapper();
    },
    setHeightWrapper() {
      // height slide-wrapper === swipe-area
      this.heightWrapper = document.querySelector('.slick-slide.slick-current.slick-active .slide-wrapper').offsetHeight;
      this.$refs["swipe-area"].style.height = this.heightWrapper  + 'px';
    },
    slickStatus() {
      if (this.$route.name === 'newsFull' || this.$route.name === 'cookie-policy' || this.$route.name === 'privacy-policy' || this.$route.name === 'company-data') {
        this.slickVisible = false;
      } else {
        this.slickVisible = true;
      }
    },
    homeStatus() {
      (this.$route.name === null || this.$route.name === 'front') ? (this.isHome = true) : (this.isHome = false);
      (this.$route.name === null) ? (this.introAnimation = true) : (this.introAnimation = false);
    },

    // Menu animations.
    menuAnimations() {

    },

  },
  components: {
    Slide,
    Header,
    Slick,
    Loading,
    Footer,
    FooterHome,
    Intro,
  },
  watch: {
    '$route'(to, from) {
      this.slickStatus();
      this.homeStatus();
      // Assign parameters to Page.vue
      let i = this.pagePaths.indexOf(this.$route.path);
      this.pageUUID = this.pageUUIDs[i];
      this.pagePath = this.pagePaths[i];

    }
  }
}
</script>

<style lang="scss">
@import 'assets/scss/master.scss';
</style>
